export const ContractDecisionVI = {
    "decisionContract": {
        "heading": {
            "detail": "Chi tiết quyết định chấm dứt hợp đồng",
            "info": "Thông tin chung",
            "reason": "Tạo mới lý do chấm dứt hợp đồng",
            "add": "Tạo mới quyết định chấm dứt hợp dồng",
            "update": "Cập nhật quyết định chấm dứt hợp dồng"
        },
        "label": {
            "no": "Số quyết định",
            "decisionDate": "Ngày quyết đinh",
            "decisionMaker": "Cấp quyết định",
            "validityDate": "Ngày hiệu lực",
            "employee": "Nhân viên",
            "reason": "Lý do chấm dứt hợp đồng",
            "description": "Mô tả",
            "status": "Trạng thái"
        },
        "placeholder": {
            "no": "Nhập số quyết định",
            "decisionDate": "Nhập Ngày quyết đinh",
            "decisionMaker": "Nhập Cấp quyết định",
            "validityDate": "Nhập Ngày hiệu lực",
            "employee": "Nhập Nhân viên",
            "reason": "Nhập Lý do chấm dứt hợp đồng",
            "description": "Nhập Mô tả"
        },
        "message": {
            "add": "Thêm thành công",
            "update": "Cập nhật thành công"
        },
        "values": {
            "status": {
                "pending": "Đang chờ duyệt",
                "approved": "Đã duyệt"
            },
            "reason": {
                "active": "Hoạt động",
                "inactive": "Không hoạt động"
            }
        }
    }
}